module.exports = __webpack_public_path__ + "static/img/xl2.795d4ef.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/control2/xl2.png
// module id = i8XH
// module chunks = 7